import { toolTipMessages } from "../../../constants";
import TitleToolTip from "./TitleToolTip";

const StockAuditItemsToolTip = (props) => {
  const { text = "items", className } = props;
  return (
    <TitleToolTip title={toolTipMessages.STOCK_AUDIT_ITEMS}>
      <span className={className}> {text} </span>
    </TitleToolTip>
  );
};

export default StockAuditItemsToolTip;
